import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  TaskFieldChanged,
  TaskMultiSelectFieldChanged,
  TaskSingleSelectFieldChanged,
} from 'api/notifications/meta';
import { Strong, Value } from '../basics';
import { Causer } from './causer';
import { renderFieldValue, FieldChangedMessage } from './field-changed';

const Single: FC<{ meta: TaskSingleSelectFieldChanged }> = ({
  meta: { by, from, to, name },
}) => (
  <FieldChangedMessage
    name={name.toLowerCase()}
    by={by}
    from={renderFieldValue(from)}
    to={renderFieldValue(to)}
  />
);

const Multi: FC<{ meta: TaskMultiSelectFieldChanged }> = ({
  meta: { by, addition, removal, name },
}) => {
  const action = addition == null ? 'removed' : 'added';

  return (
    <FormattedMessage
      id={`notifications.messages.task_field_${action}`}
      values={{
        causer: <Causer user={by} />,
        name: <Strong>{name.toLowerCase()}</Strong>,
        value: <Value>{renderFieldValue(addition || removal)}</Value>,
        action,
      }}
    />
  );
};

export const TaskFieldChangedView: FC<{ meta: TaskFieldChanged }> = ({
  meta,
}) => {
  return (
    <>
      {(meta as TaskSingleSelectFieldChanged).from != null ||
      (meta as TaskSingleSelectFieldChanged).to != null ? (
        <Single meta={meta as TaskSingleSelectFieldChanged} />
      ) : (
        <Multi meta={meta as TaskMultiSelectFieldChanged} />
      )}
    </>
  );
};
